export default "__VITE_ASSET__35948db4__"